function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _slice from 'lodash/slice';
import _pullAllBy from 'lodash/pullAllBy';
import _last from 'lodash/last';
import Dropdown from '../Dropdown/Dropdown';
import DropdownItem from '../Dropdown/DropdownItem';
import Input from '../Input';
import Button from '../Button';
import Row from '../Layout/Row';
import Col from '../Layout/Col';
var propTypes = {
  id: PropTypes.string,
  maxPages: PropTypes.number,
  pageRange: PropTypes.number,
  pageStartRange: PropTypes.number,
  // pageEndRange: PropTypes.number,
  showPageInfo: PropTypes.bool,
  showPageJump: PropTypes.bool,
  showPageSizeOptions: PropTypes.bool,
  canPrevious: PropTypes.bool,
  canNext: PropTypes.bool,
  pageSizeOptions: PropTypes.array,
  pageText: PropTypes.string,
  ofText: PropTypes.string,
  previousText: PropTypes.string,
  page: PropTypes.number,
  pages: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  pageSizeDropUp: PropTypes.bool,
  resultsPerPageText: PropTypes.string
};
var defaultProps = {
  maxPages: 4,
  pageRange: 5,
  pageStartRange: 2,
  // pageEndRange: 2,
  pageSizeDropUp: false,
  resultsPerPageText: 'Rows'
};

var PaginationTablet = /*#__PURE__*/function (_Component) {
  _inherits(PaginationTablet, _Component);

  var _super = _createSuper(PaginationTablet);

  function PaginationTablet(props) {
    var _this;

    _classCallCheck(this, PaginationTablet);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "goPreviousPage", function () {
      var canPrevious = _this.props.canPrevious;
      var page = _this.state.page;
      if (!canPrevious) return;

      _this.changePage(page - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "goNextPage", function () {
      var canNext = _this.props.canNext;
      var page = _this.state.page;
      if (!canNext) return;

      _this.changePage(page + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "goLastPage", function () {
      var _this$props = _this.props,
          canNext = _this$props.canNext,
          pages = _this$props.pages;
      var pageArray = Array(pages).fill().map(function (v, i) {
        return i + 1;
      });
      if (!canNext) return;

      _this.changePage(pageArray.length - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "goFirstPage", function () {
      var canPrevious = _this.props.canPrevious;
      if (!canPrevious) return;

      _this.changePage(0);
    });

    _this.getSafePage = _this.getSafePage.bind(_assertThisInitialized(_this));
    _this.changePage = _this.changePage.bind(_assertThisInitialized(_this));
    _this.applyPage = _this.applyPage.bind(_assertThisInitialized(_this));
    _this.state = {
      page: props.page
    };
    return _this;
  }

  _createClass(PaginationTablet, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.page !== this.props.page) {
        this.setState({
          page: this.props.page
        });
      }
    }
  }, {
    key: "getSafePage",
    value: function getSafePage(pageArg) {
      var _this$props2 = this.props,
          page = _this$props2.page,
          pages = _this$props2.pages;
      var calcPage = Number.isNaN(pageArg) ? page : pageArg;
      return Math.min(Math.max(calcPage, 0), pages - 1);
    }
  }, {
    key: "changePage",
    value: function changePage(pageArg) {
      var _this$props3 = this.props,
          page = _this$props3.page,
          onPageChange = _this$props3.onPageChange;
      var calcPage = this.getSafePage(pageArg);
      this.setState({
        page: calcPage
      });

      if (page !== calcPage) {
        onPageChange(calcPage);
      }
    }
  }, {
    key: "applyPage",
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }

      var page = this.state.page; // eslint-disable-next-line react/destructuring-assignment

      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          id = _this$props4.id,
          pages = _this$props4.pages,
          ofText = _this$props4.ofText,
          page = _this$props4.page,
          pageRange = _this$props4.pageRange,
          showPageSizeOptions = _this$props4.showPageSizeOptions,
          pageSizeOptions = _this$props4.pageSizeOptions,
          pageSize = _this$props4.pageSize,
          pageText = _this$props4.pageText,
          previousText = _this$props4.previousText,
          showPageInfo = _this$props4.showPageInfo,
          showPageJump = _this$props4.showPageJump,
          canPrevious = _this$props4.canPrevious,
          canNext = _this$props4.canNext,
          onPageSizeChange = _this$props4.onPageSizeChange,
          maxPages = _this$props4.maxPages,
          pageStartRange = _this$props4.pageStartRange,
          pageSizeDropUp = _this$props4.pageSizeDropUp,
          resultsPerPageText = _this$props4.resultsPerPageText; // const paginationArray = [1, 2, '...', 10, 11, 12, 13, 14, '...', 49, 50];\
      // [1, 2, ..., 5, 6, 7, 8, 9, 10, 11]

      var pageArray = Array(pages).fill().map(function (v, i) {
        return i + 1;
      });

      var sliced = _slice(pageArray, pageRange); //


      var paginationArray = function paginationArray(pageNumber) {
        var newArray;
        var activeArray;

        if (pageNumber - 2 >= pageStartRange) {
          activeArray = [pageNumber - 2, pageNumber - 1, pageNumber, pageNumber + 1, pageNumber + 2];
        }

        if (pageArray.length >= maxPages) {
          var newPageArray = Array(pages).fill().map(function (v, i) {
            return i + 1;
          });
          newArray = _pullAllBy(newPageArray, sliced);
        } else {
          newArray = pageArray;
        }

        if (pageNumber - 2 >= pageStartRange && pageNumber + 2 < _last(pageArray)) {
          newArray = activeArray;
        }

        if (pageNumber + 2 >= _last(pageArray) && pages > maxPages) {
          var _newPageArray = Array(pages).fill().map(function (v, i) {
            return i + 1;
          });

          var newSliced = _slice(pageArray, activeArray, pageArray.length - pageRange);

          newArray = _pullAllBy(_newPageArray, newSliced);
        }

        return /*#__PURE__*/React.createElement("span", null, newArray.map(function (pageVal, i) {
          return /*#__PURE__*/React.createElement("span", {
            key: pageVal
          }, /*#__PURE__*/React.createElement(Button, {
            kind: "secondary",
            size: "small",
            onClick: function onClick() {
              _this2.changePage(pageVal - 1);
            },
            className: // eslint-disable-next-line react/destructuring-assignment
            pageVal === _this2.state.page + 1 ? 'page__item page__item-skin--active' : 'page__item',
            "aria-label": // eslint-disable-next-line react/destructuring-assignment
            pageVal === _this2.state.page + 1 ? "Page ".concat(pageVal, ", Current Page") : "Go to page ".concat(pageVal),
            "aria-current": // eslint-disable-next-line react/destructuring-assignment
            pageVal !== _this2.state.page + 1 && false
          }, pageVal), pageVal + 1 !== newArray[i + 1] && newArray[i + 1] !== undefined && pages > maxPages && /*#__PURE__*/React.createElement("span", {
            className: "page__item paddingtop-md"
          }, "..."));
        }));
      };

      return /*#__PURE__*/React.createElement(Row, {
        justify: "center"
      }, /*#__PURE__*/React.createElement(Col, null, showPageInfo ? /*#__PURE__*/React.createElement("div", {
        className: "pagination__input"
      }, /*#__PURE__*/React.createElement("span", {
        className: "-pageInfo"
      }, pageText, "\xA0"), showPageJump ? /*#__PURE__*/React.createElement(Input, {
        name: id ? "".concat(id, "_pageJump") : 'pageJump',
        className: "page__input",
        "aria-label": "Page number of ".concat(pages, " ").concat(pages > 1 ? 'pages' : 'page'),
        size: "small",
        value: // eslint-disable-next-line react/destructuring-assignment
        this.state.page === '' ? '' : // eslint-disable-next-line react/destructuring-assignment
        this.state.page + 1,
        onChange: function onChange(e) {
          var val = e.target.value;
          var pageNumber = val - 1;

          if (val === '') {
            return _this2.setState({
              page: val
            });
          }

          return _this2.setState({
            page: _this2.getSafePage(pageNumber)
          });
        },
        onBlur: this.applyPage,
        onKeyPress: function onKeyPress(e) {
          if (e.which === 13 || e.keyCode === 13) {
            _this2.applyPage();
          }
        }
      }) : /*#__PURE__*/React.createElement("span", {
        className: "-currentPage"
      }, page + 1, "\xA0"), ofText, /*#__PURE__*/React.createElement("span", {
        className: "-totalPages"
      }, "\xA0", pages || 1)) : null), /*#__PURE__*/React.createElement(Col, {
        className: "col-auto"
      }, /*#__PURE__*/React.createElement("center", null, /*#__PURE__*/React.createElement("div", {
        className: "pagination",
        role: "navigation",
        "aria-label": "Pagination Navigation"
      }, /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_to_beginning",
        onClick: this.goFirstPage,
        disabled: !canPrevious,
        className: "marginright-md",
        "aria-label": "Go to first page"
      }, previousText), /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_back",
        onClick: this.goPreviousPage,
        disabled: !canPrevious,
        className: "marginright-md",
        "aria-label": "Go to previous page"
      }, previousText), paginationArray(this.state.page + 1), /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_forward",
        onClick: this.goNextPage,
        disabled: !canNext,
        className: "marginright-md",
        "aria-label": "Go to next page"
      }), /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_to_end",
        onClick: this.goLastPage,
        disabled: !canNext,
        className: "marginright-md",
        "aria-label": "Go to last page"
      }, previousText)))), /*#__PURE__*/React.createElement(Col, null, showPageSizeOptions && /*#__PURE__*/React.createElement("div", {
        className: "pagination__size"
      }, /*#__PURE__*/React.createElement("div", {
        className: "display-inlineblock marginright-md",
        id: id ? "".concat(id, "_pageSize-DropdownField-Label") : "pageSize-DropdownField-Label"
      }, resultsPerPageText), /*#__PURE__*/React.createElement(Dropdown, {
        onChange: function onChange(e) {
          return onPageSizeChange(e.value);
        },
        value: pageSize,
        alignRight: true,
        panelWidth: 72,
        labelWidth: 72,
        dropUp: pageSizeDropUp,
        id: id ? "".concat(id, "_pageSize") : 'pageSize'
      }, pageSizeOptions.map(function (option) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement(DropdownItem, {
            value: option,
            itemText: option,
            key: option.toString()
          })
        );
      })))));
    }
  }]);

  return PaginationTablet;
}(Component);

PaginationTablet.propTypes = propTypes;
PaginationTablet.defaultProps = defaultProps;
PaginationTablet.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getSafePage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "pageArg",
      "type": null
    }],
    "returns": null
  }, {
    "name": "goPreviousPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "goNextPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "goLastPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "goFirstPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "changePage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "pageArg",
      "type": null
    }],
    "returns": null
  }, {
    "name": "applyPage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "PaginationTablet",
  "props": {
    "maxPages": {
      "defaultValue": {
        "value": "4",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "pageRange": {
      "defaultValue": {
        "value": "5",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "pageStartRange": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "pageSizeDropUp": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "resultsPerPageText": {
      "defaultValue": {
        "value": "'Rows'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "showPageInfo": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "showPageJump": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "showPageSizeOptions": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "canPrevious": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "canNext": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "pageSizeOptions": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "pageText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "ofText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "previousText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "page": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "pages": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "pageSize": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onPageChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onPageSizeChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default PaginationTablet;